import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  blurInput(event) {
    if (event.keyCode === 27) {
      this.element.blur();
    }
  }
}
